import React from "react";
import styles from "./Terms&Policy.module.css";

const TermsIndex = () => {
  return (
    <div className={styles.container}>
      <div className={styles.content_wrap}>
        {/* title */}
        <div className={styles.page_subtitle}>
          <h1>TERMS & CONDITIONS</h1>
          <p>
            PLEASE READ THE FOLLOWING TERMS AND CONDITIONS OF USE (“TERMS OF
            USE”) CAREFULLY BEFORE USING THIS WEBSITE
          </p>
        </div>

        {/* content */}
        <div className={styles.info_content}>
          {/* intro info */}
          <div className={styles.inner_content}>
            <p>
              All users of this website (www.bodyfriend.com.my) agree that
              access to and use of this website is subject to the following
              terms and conditions and other applicable laws.{" "}
              <strong>
                IF YOU DO NOT AGREE TO THESE TERMS AND CONDITIONS, PLEASE DO NOT
                USE THIS WEBSITE.
              </strong>
            </p>
            <p>
              <strong>
                HEALTHY WORLD LIFESTYLE SDN. BHD. (herein also known as 'HWL')
              </strong>
              reserves the right to modify, add or remove these Terms of Use at
              any time. You agree to check these Terms of Use periodically to be
              aware of such modifications and that your continued use of the
              website shall be deemed to be your conclusive agreement and
              acceptance of any modified Terms of Use. We will indicate that
              changes to these Terms of Use have been made by updating the date
              indicated after “Last Modified” at the end of these Terms of Use.
              If you do not agree to abide by any modified version of these
              Terms of Use, you are not authorized to use this website.
            </p>
            <p>
              This website section, www.bodyfriend.com.my is wholly owned by{" "}
              <strong>HEALTHY WORLD LIFESTYLE SDN. BHD.</strong> All content
              contained on this website is the property of <strong>HWL</strong>.
              Users who access and use this website shall accept without
              limitation or qualification, all the Terms and Conditions stated
              and shall automatically be bound by the mentioned terms and
              conditions upon using the website. By using this website you
              represent that you have read and understood the terms and
              conditions stated herein and that you agree to be bound by them.
              The user may not copy, distribute, publish or commercially exploit
              the content of this website, or use this website unlawfully. This
              website may only be used for lawful purposes, and in a manner
              which does not violate the rights of, or restrict or inhibit the
              use of this website by a third party.
            </p>
          </div>

          {/* copyright */}
          <div className={styles.inner_content}>
            <h2>Copyright</h2>
            <p>
              The entire content included in this website, including but not
              limited to text, graphics, user interfaces, photographs, logo,
              sounds, audio clips, artworkor code is copyrighted as a collective
              work under Malaysia and other copyright laws, and is the property
              of <strong>HEALTHY WORLD LIFESTYLE SDN. BHD.</strong> The
              collective work includes works that are licensed to{" "}
              <strong>HEALTHY WORLD LIFESTYLE SDN. BHD.</strong> You may display
              and, subject to any expressly stated restrictions or limitations
              relating to specific material, download or print portions of the
              material from the different areas of the website without any
              modifications to such information solely for your own personal
              non-commercial use, or to place an order with{" "}
              <strong>HEALTHY WORLD LIFESTYLE SDN. BHD.</strong> or to purchase{" "}
              <strong>HEALTHY WORLD LIFESTYLE SDN. BHD.</strong> products. Any
              other use, including but not limited to the broadcasting,
              translation, reproduction, distribution, display or transmission
              of the content of this website is strictly prohibited, unless
              authorized by <strong>HEALTHY WORLD LIFESTYLE SDN. BHD.</strong>
              in writing prior to such use. You further agree not to change or
              delete any proprietary notice from materials downloaded or printed
              from the website.
            </p>
          </div>

          {/* Trademarks / Intellectual Property */}
          <div className={styles.inner_content}>
            <h2>Trademarks / Intellectual Property</h2>
            <p>
              In an attempt to facilitateto our visitors, HEALTHY WORLD
              LIFESTYLE SDN. BHD. may link to websites operated by third
              parties. However, even if the third party is affiliated with
              <strong>HEALTHY WORLD LIFESTYLE SDN. BHD.</strong>, HEALTHY WORLD
              LIFESTYLE SDN. BHD. has no control over these linked websites, all
              of which have separate terms and conditions and privacy and data
              collection practices, independent of{" "}
              <strong>
                HEALTHY WORLD LIFESTYLE SDN. BHD. HEALTHY WORLD LIFESTYLE SDN.
                BHD.
              </strong>{" "}
              is not responsible for and does not endorse the content of such
              Third Party Links, including any information and material
              contained therein. These linked websites are only for your
              convenience and therefore you access them at your own risk.{" "}
              <strong>HEALTHY WORLD LIFESTYLE SDN. BHD.</strong> seeks to
              protect the integrity of the website and the links placed upon it
              and therefore requests any feedback about the website and for
              websites it links to as well. Please review the privacy policy and
              the terms and conditions of any third-party website that you have
              linked to from the Website before you use such third-party
              website.
            </p>
          </div>

          {/* indemnification */}
          <div className={styles.inner_content}>
            <h2>Indemnification</h2>
            <p>
              You agree to indemnify, defend, and hold harmless{" "}
              <strong>HEALTHY WORLD LIFESTYLE SDN. BHD.</strong>, its officers,
              shareholders, directors, employees, agents, licensors, successors
              in interest, subsidiariesand suppliers from and against all
              liabilities, claims, losses, expenses, damages and costs,
              including, without limitation, reasonable legal fees, arising from
              or relating in any way to your use of this website.
            </p>
          </div>

          {/* privacy */}
          <div className={styles.inner_content}>
            <h2>Privacy</h2>
            <p>
              <strong>HEALTHY WORLD LIFESTYLE SDN. BHD.</strong> is committed to
              safeguarding your privacy. The terms regulating the handling of
              personally identifiable information and other information by you
              in connection with the website is described in our Privacy Policy
              which forms part of these Terms of Use by reference. To view our
              Privacy Policy, click here.
            </p>
          </div>

          {/* warranty disclaimer */}
          <div className={styles.inner_content}>
            <h2>Warranty Disclaimer</h2>
            <p>
              The information is provided so that you can achieve a more healthy
              and active lifestyle. However, it does not replace treatment
              advice you may obtain by consulting a medical professional. If you
              experience any emergency situations, you should contact your
              healthcare professional immediately. The materials in this site
              are provided “as is” and without warranties of any kind whether
              express or implied. To the fullest extent permissible pursuant to
              applicable law, <strong>HEALTHY WORLD LIFESTYLE SDN. BHD.</strong>{" "}
              disclaims all warranties, express or implied, including but not
              limited to, implied warranties of merchantability and fitness for
              a particular purpose.{" "}
              <strong>HEALTHY WORLD LIFESTYLE SDN. BHD.</strong> does not
              warrant that the functions contained in the materials will be
              uninterrupted or error-free, that defects will be corrected, or
              that this site or the server that makes it available are free of
              viruses or other harmful components. The Product does not warrant
              or make any representations regarding the use or the results of
              the use of the materials in this site in terms of their
              correctness, accuracy, reliability, or otherwise. You (and not
              HWL) assume the entire cost of all necessary servicing, repair, or
              correction. Applicable law may not allow the exclusion of implied
              warranties, so the above exclusion may not apply to you.
            </p>
          </div>

          {/* limitation of liability */}
          <div className={styles.inner_content}>
            <h2>Limitation of Liability</h2>
            <p>
              HEALTHY WORLD LIFESTYLE SDN. BHD. SHALL NOT BE LIABLE FOR ANY
              DIRECT, SPECIAL, INCIDENTAL, INDIRECT OR CONSEQUENTIAL DAMAGES
              THAT RESULT FROM THE USE OF, OR THE INABILITY TO USE, THE
              MATERIALS ON THIS WEBSITE OR THE PERFORMANCE OF THE PRODUCTS
              PURCHASED THROUGH THE WEBSITE OR THE CONDUCT OF OTHER USERS OF
              THIS WEBSITE, EVEN IF HEALTHY WORLD LIFESTYLE SDN. BHD. HAS BEEN
              ADVISED OF THE POSSIBILITY OF SUCH DAMAGES. IF, NOTWITHSTANDING
              THE OTHER PROVISIONS OF THESE TERMS OF USE, HEALTHY WORLD
              LIFESTYLE SDN. BHD. IS FOUND TO BE LIABLE TO YOU FOR ANY DAMAGE OR
              LOSS WHICH ARISES OUT OF OR IS IN ANY WAY CONNECTED WITH YOUR USE
              OF THIS WEBSITE OR ANY CONTENT, HEALTHY WORLD LIFESTYLE SDN. BHD.
              LIABILITY SHALL IN NO EVENT EXCEED USD100.00. APPLICABLE LAW MAY
              NOT ALLOW THE LIMITATION OR EXCLUSION OF LIABILITY OR INCIDENTAL
              OR CONSEQUENTIAL DAMAGES, SO THE ABOVE LIMITATION OR EXCLUSION MAY
              NOT APPLY TO YOU.
            </p>
          </div>

          {/* miscellaneous */}
          <div className={styles.inner_content}>
            <h2>Miscellaneous</h2>
            <p>
              All matters relating to your Access to or use of this site,
              including all disputes shall be governed in all respects by the
              laws of Malaysia , without regard to choice of law provisions, and
              not by the 1980 U.N. Convention on contracts for the international
              sale of goods. Except where prohibited, you agree that any and all
              disputes, claims and legal proceedings directly or indirectly
              arising out of or relating to this website (including but not
              limited to the purchase of{" "}
              <strong>HEALTHY WORLD LIFESTYLE SDN. BHD.</strong>
              products) shall be resolved promptly and in good faith between the
              parties by negotiation. If the parties are unable to resolve any
              such dispute within a reasonable time not to exceed sixty (60)
              days then either party may submit such controversy or dispute to
              mediation. If the dispute cannot be resolved through mediation,
              then the parties shall be free to pursue any right or remedy
              available to them PROVIDED ALWAYS that such dispute shall be
              brought individually, without resort to any form of class action,
              and exclusively in the state or federal courts located in Malaysia
              . Any cause of action or claim you may have with respect to the
              website (including but not limited to the purchase of HEALTHY
              WORLD LIFESTYLE SDN. BHD. products) must be commenced within one
              (1) year after the claim or cause of action arises. By using the
              website, you agree to receive electronic communications from
              <strong>HEALTHY WORLD LIFESTYLE SDN. BHD.</strong> You agree that
              any notice, agreement, disclosure or other communication that
              HEALTHY WORLD LIFESTYLE SDN. BHD. sends you electronically will
              satisfy any legal communication requirements, including that such
              communications be in writing.{" "}
              <strong>HEALTHY WORLD LIFESTYLE SDN. BHD.</strong>'s failure to
              insist upon or enforce strict performance of any provision of
              these terms and conditions shall not be construed as a waiver of
              any provision or right. Neither the course of conduct between the
              parties nor trade practice shall act to modify any of these terms
              and conditions. <strong>HEALTHY WORLD LIFESTYLE SDN. BHD.</strong>{" "}
              may assign its rights and duties under this Agreement to any party
              at any time without notice to you.
            </p>
          </div>

          {/* term termination */}
          <div className={styles.inner_content}>
            <h2>Term Termination</h2>
            <p>
              These terms and conditions are applicable to you upon your
              accessing the website.{" "}
              <strong>HEALTHY WORLD LIFESTYLE SDN. BHD.</strong> reserves the
              right in its sole discretion to terminate or restrict your use of
              the website, without notice, for any or no reason, and without
              liability to you or any third party. In addition, these terms and
              conditions, or any part of them, may be terminated by{" "}
              <strong>HEALTHY WORLD LIFESTYLE SDN. BHD.</strong> without notice
              at any time, for any reason. The provisions relating to Copyright,
              Trademarks, Disclaimer, Limitation of Liability, Indemnification
              and Miscellaneous, shall survive any termination.
            </p>
          </div>

          {/* other */}
          <div className={styles.inner_content}>
            <h2>Other</h2>
            <p>
              If any provision of these terms shall be unlawful, void, or for
              any reason unenforceable, then that provision shall be deemed
              severable from these terms and shall not affect the validity and
              enforceability of any remaining provisions. This is the entire
              agreement between us relating to the subject matter herein and
              shall not be modified except in writing, signed by both parties.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TermsIndex;
